import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { getFilteredPassings, getPassingsFilterPagination, showCheckboxColumn, passingsToExport } from 'api/passings/getFilteredPassings';
import { PrimaryButton } from 'components/Button';
import DividerComponent from 'components/Divider/Divider';
import Pagination from 'components/Pagination/Pagination';
import PassingList from 'components/PassingsList/PassingList';
import Spinner from 'components/Spinner/Spinner';
import { Header } from 'components/Text';
import checkLoadable from 'utils/recoil/checkLoadable';
import ArchivedPassingsDownload from './ArchivedPassingsDownload';
import PassingsDownload from './PassingsDownload';
import PassingsFilterForm from './PassingsFilterForm';
import { EnumArchiveStatus } from 'api';
import InfoOutlined from "@material-ui/icons/esm/InfoOutlined";
import Box from '@material-ui/core/Box/Box';
import { LIGHT_PRIMARY } from 'constants/colors';
export default function Passings() {
  const {
    t
  } = useTranslation();
  const passingsLoadable = useRecoilValueLoadable(getFilteredPassings);
  const {
    contents: passings,
    loading
  } = checkLoadable(passingsLoadable);
  const [pagination, setPagination] = useRecoilState(getPassingsFilterPagination);
  const [showCheckbox, setShowCheckbox] = useRecoilState(showCheckboxColumn);
  const setPassingsToExport = useSetRecoilState(passingsToExport);
  const handleSpecificExportButtonOnClick = () => {
    if (showCheckbox) {
      setPassingsToExport([]);
    }
    setShowCheckbox(!showCheckbox);
  };
  useEffect(() => {
    setPassingsToExport([]);
    setShowCheckbox(false);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, t('passings.passings')), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ArchivedPassingsDownload, {
    disabled: false
  }), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(Box, {
    bgcolor: LIGHT_PRIMARY,
    padding: '1rem',
    borderRadius: '5px',
    fontSize: 'medium',
    position: 'relative'
  }, /*#__PURE__*/React.createElement(InfoOutlined, {
    style: {
      position: 'absolute',
      top: '1rem',
      left: '1rem'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: '2rem'
    }
  }, t('passings.information_box_not_archived'))), /*#__PURE__*/React.createElement(PassingsFilterForm, null), /*#__PURE__*/React.createElement(PrimaryButton, {
    onClick: () => handleSpecificExportButtonOnClick()
  }, t('passings.export_specific_passings')), /*#__PURE__*/React.createElement(PassingsDownload, null), loading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(PassingList, {
    items: passings?.results?.filter(passing => passing.archiveStatus !== EnumArchiveStatus.Verified) ?? []
  }), /*#__PURE__*/React.createElement(Pagination, {
    totalResults: passings?.totalResults ?? 0,
    handlePagination: setPagination,
    paginationParams: pagination,
    rowsPerPageOptions: [5, 10, 30, 100]
  }));
}